import { VIF_CONSTANTS } from 'common/authoring_workflow/constants';
import { type Vif } from 'common/visualizations/vif';

export const defaultDataTableVif: Vif = {
  format: {
    type: 'visualization_interchange_format',
    version: VIF_CONSTANTS.LATEST_VERSION,
  },
  configuration: {
    viewSourceDataLink: false,
  },
  description: '',
  series: [
    {
      color: {},
      dataSource: {
        datasetUid: null,
        dimension: {
          columnName: null,
          aggregationFunction: null,
        },
        measure: {
          columnName: null,
          aggregationFunction: 'count',
        },
        type: 'socrata.soql',
        filters: [],
      },
      label: null,
      type: 'dataTable',
      unit: {
        one: 'row',
        other: 'rows',
      },
    },
  ],
  title: '',
};
